import { getRecordedClasses, addRecordedClass } from '../recorded-classes';
import { exportActivities } from './index';

const exportRecordedClasses = data => {
    return exportActivities({ ...data, getter: getRecordedClasses, adder: addRecordedClass });
};

export default exportRecordedClasses;
